import { toBoolOrNull, toIntOrNull } from '@utils/parse';
import { useApiModel } from '@hooks/use-api-model';
import { useApiSubmit } from '@hooks/use-api-submit';
import { DashRegistrationStep } from '@/types/dashboard';
import { defaultScreeningProgress } from '@/types/screening/screening-progress';
import type {
    IAssessDiabetesFormValues,
    IAssessDiabetesModel,
    IAssessDiabetesSubmitResult,
} from '@/types/screening/assess-diabetes';

const ASSESS_DIABETES_ENDPOINT = '/api/register/assess-diabetes';

const defaultAssessDiabetesModel: IAssessDiabetesModel = {
    ...defaultScreeningProgress,
    currentRegistrationStep: DashRegistrationStep.AssessDiabetes,

    hasDiabetes: null,
    diabetesStatus: null,
};

export const useAssessDiabetes = (registrationId: number, editKey: string) => {
    const url = `${ASSESS_DIABETES_ENDPOINT}/${registrationId}/${editKey}`;

    const { model, isLoading, error } = useApiModel(url, defaultAssessDiabetesModel);

    const { submit, isSubmitting, submitError } = useApiSubmit<IAssessDiabetesFormValues, DashRegistrationStep, IAssessDiabetesSubmitResult>(
        url,
        (values) => {
            const hasDiabetes = toBoolOrNull(values.hasDiabetes);
            const diabetesStatus = hasDiabetes === true ? toIntOrNull(values.diabetesStatus) : null;

            return {
                hasDiabetes,
                diabetesStatus,
            };
        },
        (nextStep) => ({ nextStep }),
    );

    return { model, isLoading, error, submit, isSubmitting, submitError };
};
